import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { GallopHttpClient } from '../shared/gallop-httpclient.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-checkin-issue-modal',
    templateUrl: './checkin-issue-modal.component.html',
    styleUrls: ['./checkin-issue-modal.component.scss'],
    standalone: false
})
export class CheckinIssueModalComponent implements OnInit {
  @Input() hotelName: string = '';
  @Input() bookingId: string = '';
  @Input() eventId: string = '';
  @Input() tripId: string = '';
  @Input() optionId: string = '';
  @Input() transactionId: string = '';

  issueDescription: string = '';
  isSubmitting: boolean = false;
  onSubmitSuccess: Subject<boolean> = new Subject<boolean>();

  constructor(
    public bsModalRef: BsModalRef,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private gallopHttpClient: GallopHttpClient
  ) { }

  ngOnInit(): void {
  }

  onSubmit(): void {
    if (!this.issueDescription || this.issueDescription.trim().length === 0) {
      this.toastr.error('Please describe the issue before submitting.');
      return;
    }

    this.isSubmitting = true;

    const payload = {
      event_id: this.eventId,
      trip_id: this.tripId,
      option_id: this.optionId,
      transaction_id: this.transactionId,
      text_message: this.issueDescription.trim()
    };

    this.gallopHttpClient.post(environment.apiForCheckinIssueReport, payload).subscribe({
      next: (response: any) => {
        this.isSubmitting = false;
        this.toastr.success('Your check-in issue has been reported. Our support team will contact the hotel shortly.');
        this.onSubmitSuccess.next(true);
        this.bsModalRef.hide();
      },
      error: (error) => {
        this.isSubmitting = false;
        this.toastr.error('Failed to submit the issue report. Please try again.');
      }
    });
  }

  onClose(): void {
    this.bsModalRef.hide();
  }
}
